import { PROGRAMS } from '../data/content'
import ProgramCard from './ProgramCard'

function ProgramsSection() {
  return (
    <section id="programs" className="relative py-20 px-4 bg-gradient-to-b from-white to-brand-blue-light/10 scroll-mt-20 overflow-hidden">
      {/* Decorative cloud blob - right side */}
      <svg
        className="absolute -top-10 -right-40 w-[600px] h-[400px] text-brand-blue opacity-10"
        viewBox="0 0 200 150"
        fill="currentColor"
      >
        <ellipse cx="100" cy="80" rx="90" ry="60" />
        <ellipse cx="60" cy="90" rx="50" ry="40" />
        <ellipse cx="140" cy="85" rx="55" ry="45" />
      </svg>

      {/* Decorative dot */}
      <div className="absolute left-20 top-1/4 hidden lg:block">
        <div className="w-4 h-4 rounded-full bg-brand-blue opacity-40"></div>
      </div>

      {/* Plus sign */}
      <div className="absolute right-20 bottom-1/4 hidden lg:block">
        <svg className="w-6 h-6 text-brand-blue opacity-40" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
      </div>

      <div className="max-w-[1500px] mx-auto text-center px-6">
        <h3 className="text-3xl md:text-4xl font-heading font-bold text-brand-blue mb-2">
          OUR PROGRAMS
        </h3>
        <div className="w-32 h-1 bg-brand-blue mx-auto mb-6"></div>

        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-12 leading-relaxed">
          Our organization runs 3 different programs to teach and mentor students:
          Curriculum, TritonHacks, and Early Start. Learn more about each program below!
        </p>

        {/* Program Cards Grid */}
        <div className="grid md:grid-cols-3 gap-10">
          {PROGRAMS.map((program) => (
            <ProgramCard key={program.id} program={program} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default ProgramsSection
